import { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import BackButton from "../../Components/BackButton";
import CustomButton from "../../Components/CustomButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import SocialReportModal from "./SocialReportModal";
import { formatDate } from "../../utils/dateUtils";
import { toast } from "react-toastify";
import searchResultimage from "../../Assets/images/searchResult.svg";
import { FaCalendar, FaCheck, FaClock } from "react-icons/fa6";
import { saveAs } from "file-saver";

export const OrderDetail = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isShowModal = searchParams.get("showModal");
  const { id } = useParams();

  const [order, setOrder] = useState({});
  const [isSent, setIsSent] = useState(false);

  const [reports, setReports] = useState([]);
  const [reportsLinks, setReportsLinks] = useState();

  const [showModal, setShowModal] = useState(
    isShowModal == "true" ? true : false
  );

  const fetchOrder = (id) => {
    const LogoutData = localStorage.getItem("login");
    document.querySelector(".loaderBox").classList.remove("d-none");
    fetch(`${process.env.REACT_APP_BASE_URL}/orders/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${LogoutData}`,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        document.querySelector(".loaderBox").classList.add("d-none");
        setOrder(data.data);
        setReports(data.data?.reports);
        setReportsLinks(data.data?.report_links);
        // console.log('reports', data.data?.reports);
      })
      .catch((error) => {
        document.querySelector(".loaderBox").classList.add("d-none");
        console.log(error);
      });
  };

  useEffect(() => {
    document.title = "Virtual PI | User Management Detail";
    fetchOrder(id);
  }, [id]);
  useEffect(() => {
    if (isSent) {
      fetchOrder(id);
      toast.success("Social media report send to email successfully.");
    }
  }, [isSent]);

  const downloadPDF = (pdflink, pdfName) => {
    // console.log('pdf link', pdflink, 'pdf name', pdfName);

    // console.log("report", reports);

    saveAs(
      `${process.env.REACT_APP_BASE_STORAGE_URL}/${pdflink}`,
      `${pdfName}.pdf`
    );
  };

  return (
    <>
      <DashboardLayout>
        <div className="dashCard mb-4">
          <div className="d-flex mb-3 justify-content-between">
            <div className="mb-2">
              <h2 className="mainTitle">
                <BackButton />
                Order Details
              </h2>
            </div>
            {order?.is_social_media_report_sent == "0" &&
              order?.has_social_media_report == "1" && (
                <div>
                  <CustomButton
                    onClick={() => setShowModal(true)}
                    text="Send Social Media Report"
                    icon={<FontAwesomeIcon icon={faPaperPlane} />}
                    on
                    variant="primaryButton"
                  />
                </div>
              )}
          </div>
          <div className="row mb-3">
            <div className="col-12">
              {/* <div className="row mb-3 justify-content-end">
                                <div className="col-lg-4 text-end order-1 order-lg-2 mb-3">
                                <span className={`statusBadge ${user?.status == 1 ? 'statusBadgeActive' : 'statusBadgeInactive'}`}>{user?.status == 1 ? 'Active' : 'Inactive'}</span>
                                </div>
                            </div> */}

              <div className="row">
                <div className="col-md-4 mb-4">
                  <p className="secondaryText">Order ID</p>
                  <p className="text-capitalize">{order?.id}</p>
                </div>
                <div className="col-md-4 mb-4">
                  <p className="secondaryText">First Name</p>
                  <p className="text-capitalize">{order?.first_name}</p>
                </div>
                <div className="col-md-4 mb-4">
                  <p className="secondaryText">Last Name</p>
                  <p>{order?.last_name}</p>
                </div>
                {order?.email && (
                  <div className="col-md-4 mb-4">
                    <p className="secondaryText">Email</p>
                    <p>{order?.email}</p>
                  </div>
                )}
                {order?.age && (
                  <div className="col-md-4 mb-4">
                    <p className="secondaryText">Age</p>
                    <p>{order?.age}</p>
                  </div>

                )}
                {order?.full_address && (
                  <div className="col-md-4 mb-4">
                    <p className="secondaryText">Full Address</p>
                    <p>{order?.full_address}</p>
                  </div>

                )}

                <div className="col-md-4 mb-4">
                  <p className="secondaryText">User Email</p>
                  <p>{order?.user_email}</p>
                </div>
                <div className="col-md-4 mb-4">
                  <p className="secondaryText">Total</p>
                  <p>${order?.total}</p>
                </div>
                <div className="col-md-4 mb-4">
                  <p className="secondaryText">Generated Date</p>
                  <p>{formatDate(order?.created_at)}</p>
                </div>
              </div>
              <div className="row">
                <div className=" mb-4 col-md-4">
                  <p className="secondaryText">
                    Is Social Media Report Included?
                  </p>
                  {/* <p>{order?.unit_id}</p> */}
                  <p>
                    {order?.has_social_media_report == "1"
                      ? "✅ Included"
                      : "❌ Not Included"}
                  </p>
                </div>
                {order?.has_social_media_report == "1" && (
                  <div className="col-md-4">
                    <p className="secondaryText">
                      Is Social Media Report Sent?
                    </p>
                    <p>
                      {order?.is_social_media_report_sent == "1"
                        ? "✅ Sent"
                        : "🕗 Pending"}
                    </p>
                  </div>
                )}
              </div>
              <div className="row">
                <h4 className="fw-bold">Generated Report</h4>
                {reports.map((report, index) => {
                  const created = new Date(order.created_at);
                  const date = created.toLocaleString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "2-digit",
                    // hour12: true,
                  });
                  const time = created.toLocaleString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    // hour12: true,
                  });
                  return (
                    <div key={index} className="pdf-download-card col-lg-4 col-md-6 col-12 mb-3">
                      <div className="pdfcard">
                        <div className="d-flex gap-2">
                          <div className="pdf-card-left ">
                            <div className="pdf-search-image">
                              <img src={searchResultimage} alt="" />
                            </div>
                            <p className="text-dark fw-bold">{report.label}</p>
                            <p className="text-muted">
                              <FaCalendar size={14} />
                              {/* 01/31/2025 */}
                              {date}
                            </p>
                            <p className="text-muted">
                              <FaClock size={14} />
                              {time}
                            </p>
                          </div>
                          <div className="pdf-card-right ">
                            <span>
                              <FaCheck size={32} className="text-dark" />
                            </span>
                            <p className="text-white">
                              Search Request for {order.first_name}{" "}
                              {order.last_name} has been completed
                            </p>
                          </div>
                        </div>
                        <button
                          className="w-100 mt-3"
                          // to={`${import.meta.env.VITE_BASE_STORAGE_URL}/${
                          //   reportsLinks[0]
                          // }`}
                          onClick={() => downloadPDF(reportsLinks[index], report.label)}
                        >
                          Download Report
                        </button>
                      </div>
                      {/* <div className="d-flex">
                </div> */}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <SocialReportModal
          email={order?.user_email}
          showModal={showModal}
          setIsSent={setIsSent}
          closeModal={() => {
            fetchOrder(id);
            setShowModal(false);
          }}
        />
      </DashboardLayout>
    </>
  );
};
